/* MacShack Microsoft Surface page: Snapdragon-or-Intel chooser and Surface Pro mode switcher. */
(function () {
  'use strict';

  function initChooser(root) {
    var inputs = root.querySelectorAll('[data-opts] input');
    if (!inputs.length) return;
    var q = function (s) { return root.querySelector(s); };
    var dot = q('[data-dot]'), chip = q('[data-v-chip]'), name = q('[data-v-name]'), text = q('[data-v-text]'),
        list = q('[data-v-list]'), from = q('[data-v-from]'), btn = q('[data-v-btn]'), wa = q('[data-v-wa]');
    var search = (window.routes && window.routes.search_url) || '/search';
    var V = {
      snap: { cls: 'chip--snap', chip: 'Snapdragon X', name: 'Go with Snapdragon',
        text: 'Your needs run beautifully on Snapdragon. You get the longest battery life of any Surface.',
        list: ['Microsoft 365, Teams, Edge, Chrome and Zoom run natively', 'Older Windows apps run through built-in emulation', 'Copilot+ PC features built in'],
        from: root.getAttribute('data-snap-from'), fromLabel: 'Snapdragon Surface Laptops from ',
        btn: 'Shop Snapdragon Surface', url: search + '?q=Surface+Snapdragon&type=product' },
      intel: { cls: 'chip--intel', chip: 'Intel Core Ultra', name: 'Go with Intel',
        text: 'Some of what you use expects a traditional Intel PC. Intel Core Ultra runs every Windows app and driver without emulation.',
        list: ['CAD, engineering and specialist software', 'Drivers for printers, scanners and USB devices', 'Older or custom company software'],
        from: root.getAttribute('data-intel-from'), fromLabel: 'Intel Surface Laptops from ',
        btn: 'Shop Intel Surface', url: search + '?q=Surface+Intel&type=product' },
      any: { cls: 'chip--any', chip: 'Either works', name: 'Either chip will do',
        text: "Nothing you've switched on needs Intel, and nothing needs Snapdragon's extra battery. Choose on size and price.",
        list: ['Snapdragon: longer battery life', 'Intel: the widest software and driver support'],
        from: root.getAttribute('data-any-from'), fromLabel: 'Surface Laptops from ',
        btn: 'See every Surface', url: '#msf-range' }
    };
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function decide() {
      var score = 0, picked = [];
      Array.prototype.forEach.call(inputs, function (i) { if (i.checked) { score += +i.getAttribute('data-w'); picked.push(i.getAttribute('data-k')); } });
      /* CAD, specialist devices and older software are hard requirements: any one of them means Intel. */
      var hard = Array.prototype.some.call(inputs, function (i) { return i.checked && +i.getAttribute('data-w') >= 2; });
      var key = !picked.length ? 'any' : hard ? 'intel' : score < 0 ? 'snap' : 'any';
      if (hard) score = Math.max(score, 3);
      dot.style.left = Math.max(6, Math.min(94, 50 + score * 9)) + '%';
      var v = V[key];
      chip.className = 'chip ' + v.cls; chip.textContent = v.chip;
      name.textContent = picked.length ? v.name : 'Switch on what you need';
      text.textContent = picked.length ? v.text : 'Both chips run Windows 11, Microsoft 365, Teams and your browser. The toggles tell us which way to lean.';
      list.innerHTML = picked.length ? v.list.map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('') : '';
      from.innerHTML = v.from ? esc(v.fromLabel) + '<b>' + esc(v.from) + '</b>' : '';
      btn.textContent = v.btn; btn.setAttribute('href', v.url);
      if (wa) {
        var msg = 'Hi MacShack, I need a Windows laptop' + (picked.length ? ' for ' + picked.join(', ') : '') + '. Which Surface do you recommend?';
        wa.setAttribute('href', 'https://wa.me/' + root.getAttribute('data-wa') + '?text=' + encodeURIComponent(msg));
      }
    }
    Array.prototype.forEach.call(inputs, function (i) { i.addEventListener('change', decide); });
    decide();
  }

  function initModes(root) {
    var group = root.querySelector('[data-modes]'); if (!group) return;
    var btns = group.querySelectorAll('button'), text = root.querySelector('[data-mode-text]');
    var imgs = root.querySelectorAll('img[data-mode]');
    Array.prototype.forEach.call(btns, function (b) {
      b.addEventListener('click', function () {
        var m = b.getAttribute('data-m');
        Array.prototype.forEach.call(btns, function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        Array.prototype.forEach.call(imgs, function (im) { im.hidden = im.getAttribute('data-mode') !== m; });
        if (text) text.textContent = b.getAttribute('data-t');
      });
    });
  }

  function init(root) { if (root.__msf) return; root.__msf = true; initChooser(root); initModes(root); }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-msf]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
